import { ChevronRight, ChevronDown, File, Folder } from "lucide-react";

function renderNode(node, depth, onSelect, activePath, expanded, toggle) {
  const isOpen = expanded.has(node.path || "__root__");
  if (node.is_dir) {
    return (
      <div key={node.path || "__root__"}>
        <button
          onClick={() => toggle(node.path || "__root__")}
          data-testid={`nginx-tree-dir-${node.path || "root"}`}
          className="w-full flex items-center gap-1 px-2 py-1 hover:bg-[#111] text-[12px] font-mono text-[#8b8d98]"
          style={{ paddingLeft: 8 + depth * 12 }}
        >
          {isOpen ? (
            <ChevronDown className="w-3 h-3" strokeWidth={1.5} />
          ) : (
            <ChevronRight className="w-3 h-3" strokeWidth={1.5} />
          )}
          <Folder className="w-3.5 h-3.5 text-[#eab308]" strokeWidth={1.5} />
          <span className="truncate">{node.name || "/"}</span>
        </button>
        {isOpen &&
          (node.children || []).map((c) =>
            renderNode(c, depth + 1, onSelect, activePath, expanded, toggle)
          )}
      </div>
    );
  }
  return (
    <button
      key={node.path}
      onClick={() => onSelect(node)}
      data-testid={`nginx-tree-file-${node.path}`}
      className={[
        "w-full flex items-center gap-1 px-2 py-1 hover:bg-[#111] text-[12px] font-mono truncate text-left",
        activePath === node.path ? "bg-[#111] text-[#22d3ee]" : "text-[#8b8d98]",
      ].join(" ")}
      style={{ paddingLeft: 8 + depth * 12 + 12 }}
    >
      <File className="w-3.5 h-3.5" strokeWidth={1.5} />
      <span className="truncate">{node.name}</span>
    </button>
  );
}

export default function NginxTree({ tree, onSelect, activePath, expanded, toggle }) {
  if (!tree) {
    return <div className="p-4 text-xs font-mono text-[#8b8d98] animate-pulse">Lade Baum…</div>;
  }
  return <div>{renderNode(tree, 0, onSelect, activePath, expanded, toggle)}</div>;
}
